import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ToastProvider } from "./hooks/useToast";
import { ThemeProvider } from "./hooks/useTheme";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ToastProvider>
        <ThemeProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <AppRoutes />
          </BrowserRouter>
        </ThemeProvider>
      </ToastProvider>
    </I18nextProvider>
  );
}

export default App;
